export default __webpack_public_path__ + "static/media/diamond-clarity-4@3x.a8ddf34f.png";